<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :lg="3" :md="3" :span="3">
            <el-select
              value="是"
              size="medium"
              placeholder="是否贷款"
              style="width: 110px;"
              clearable
            >
              <el-option label="是" value="1" key="1"></el-option>
              <el-option label="否" value="0" key="0"></el-option>
            </el-select>
          </el-col>
          <el-col :lg="3" :md="3" :span="3">
          </el-col>
          <el-col :lg="3" :md="3" :span="3">
          </el-col>
          <el-col :lg="6" :md="6" :span="6">
          </el-col>
          <el-col :lg="4" :md="4" :span="5">
            <el-input size="medium" placeholder="搜索关键字: 姓名、手机、业务员" v-model="key" style="width: 97%;"></el-input>
          </el-col>
          <el-col :lg="2" :md="2" :span="2">
            <el-button size="medium" type="primary" icon="el-icon-search">搜索</el-button>
          </el-col>
          <el-col :lg="3" :md="3" :span="2">
            &nbsp;
            <el-button size="medium" type="success">新增车贷</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table
          :data="tableData"
          ref="multipleTable"
          tooltip-effect="dark"
          border
          fixed
          height="400"
          style="width: 100%"
        >
          <el-table-column prop="name" label="姓名" min-width="80"/>
          <el-table-column label="操作" min-width="220" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
              >编辑
              </el-button>
              <el-button
                type="danger"
                size="mini">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination
            background
            @current-change="currentPageChange"
            @size-change="pageSizeChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="pageSize"
            :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog
      :visible.sync="dialogVisible"
      @closed="resetForm('carLoanForm')"
      :title="dialogTitle + '车贷单'"
      :modal="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="carLoanForm"
        ref="carLoanForm"
        :rules="carLoanFormRules"
        label-width="120px"
        size="medium"
        style="padding: 0 10%;"
      >
        <el-form-item label="姓名" prop="name">
          <el-input clearable></el-input>
        </el-form-item>
        <el-form-item size="large">
          <span>
            <el-button>&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
            <el-button type="primary">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "pointFabulou",
        data() {
            return {
                key: '',
                tableData: [],
                currentPage: 1,
                pageSize: 20,
                totalPage: 100,
                total: 100000,
                dialogTitle: '',
                carLoanForm: {},
                carLoanFormRules: {},
                dialogVisible: false,
            }
        },
        created() {
        },
        methods: {
            currentPageChange(val) {
                this.currentPage = val;
            },
            pageSizeChange(val) {
                this.pageSize = val;
            },
            resetForm() {
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/front/pointFabulou.vue